import { JobCell } from './job-cell.model';

export class JobRatioCell {
    denominator: JobCell;
    numerator: JobCell;
    ratio: number;
}